import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { EngagementCard } from "./EngagementCard";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const EngagementPage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;

  return (
    <PageContainer title="Engagement">
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">
            Average engagement time per active user
          </Typography>
          <DateRangeNav dateRange={dateRange} />
        </Box>
        <EngagementCard startDate={startDate} endDate={endDate} />
      </Paper>
    </PageContainer>
  );
};

export default EngagementPage;
